import { GetRef, Form } from 'antd';
import React from 'react';

import { Item } from 'business/shift-report/report/pages/ReportEdit/components/mass-validation-drawer/types';

type FormInstance<T> = GetRef<typeof Form<T>>;

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null,
);

// Ant passes props to the <tr/> node
interface EditableRowProps {}

export const EditableRow = (props: EditableRowProps) => {
  const [form] = Form.useForm<Item>();

  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
